import { BaseComponent } from "../../base.component.js";
import { AbText } from '../text/text.widget.js';
import AbTooltip from "../tooltip/tooltip.widget.js";

/**
 * @typedef {object} _AbText_Props
 * @property {string|Symbol} text
 * @property {string|Symbol} tooltip
 * @property {number} maxChars
 * @property {Object.<string, string>} [params]
 * @property {boolean|'light'} emphasis
 */
export class AbCroppedText extends BaseComponent {
  /** @type {AbTooltip} */
  _tooltip;

  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    this._tooltip && this._tooltip.hide();
    super.componentWillUnmount();
  }

  componentWillUpdate() {
    this._tooltip && this._tooltip.hide();
  }
  setTooltip(tooltip) {
    if (tooltip) {
      this._tooltip = tooltip;
      this._tooltip.setTarget(this.base);
    } else if (this._tooltip) {
      this._tooltip.hide();
    }
  }
  render({ text, maxChars, ...rest }, { txt }) {
    let content = text;
    let enableTooltip = false;
    if (typeof text === 'symbol') {
      content = text;
    }
    if (maxChars && content.length > maxChars) {
      content = content.substr(0, maxChars) + "...";
      enableTooltip = true;
    }
    return (
      <span onMouseEnter={() => this._tooltip && this._tooltip.show()} onMouseLeave={() => this._tooltip && this._tooltip.hide()}>
        {enableTooltip && <AbTooltip onRef={tooltip => this.setTooltip(tooltip)} content={<div>{typeof text === 'symbol' ? txt(text) : text}</div>} />}
        <AbText text={content} {...rest} />
      </span>
    );
  }
}
